import React, { useEffect } from "react";
import { useSelector } from "react-redux";
import { useNavigate } from "react-router-dom";
import { get } from "lodash";
import { isFdr } from "@tvg/pp/src/utils/general";
import { isMobile } from "@tvg/utils/mobileUtils";
import { getRedirectTVGSignup } from "@urp/store-selectors";
import { openExternalApp } from "@tvg/utils/mediatorUtils";
import tvgConf from "@tvg/conf";

const Redirect: React.FC = () => {
  const navigate = useNavigate();
  const redirectTVGSignup = useSelector(getRedirectTVGSignup);

  useEffect(() => {
    // TODO: code to be removed when QFD-967 and QFD-968 are done.
    console.log(
      "redirectTVGSignup-packg-compo==>",
      tvgConf().product,
      isMobile(tvgConf().product),
      JSON.stringify(redirectTVGSignup)
    );
    const redirectUrl = get(redirectTVGSignup, "url_redirect");
    if (
      !isFdr() &&
      typeof window !== "undefined" &&
      get(redirectTVGSignup, "enabled", false)
    ) {
      if (isMobile(tvgConf().product)) {
        openExternalApp(redirectUrl);

        setTimeout(() => {
          navigate("/");
        }, 1000);
      } else {
        window.location.replace(redirectUrl);
      }
    }
  }, []);

  return null;
};

export default Redirect;
